import { useMutation } from '@apollo/client';
import type {
  CertificationFormType,
  ExperienceFormType,
  FormationFormType,
  LanguagesFormType,
  ProfilFormType,
} from '@/types/form';
import { UPDATE_PROFILE_MUTATION } from '@/api/profile';

export const usePatchProfil = () => {
  const [updateUser, { loading, error }] = useMutation(UPDATE_PROFILE_MUTATION);

  const mutate = async (
    experiencesValues: ExperienceFormType,
    languagesValues: LanguagesFormType,
    formationsValues: FormationFormType,
    certificationsValues: CertificationFormType,
    profilValues: ProfilFormType
  ) => {
    await updateUser({
      variables: {
        data: {
          location: profilValues.location,
          skills: profilValues.skills,
          headline: profilValues.headline,
          summary: profilValues.summary,
          complete_name: profilValues.completeName,
          phone: profilValues.phone,
          certifications: certificationsValues.certifications.map(certif => ({
            date: certif.date,
            title: certif.title,
            url: certif.url,
            deliveredBy: certif.deliveredBy || '',
          })),
          experiences: experiencesValues.experiences.map(exp => ({
            companyName: exp.companyName,
            description: exp.description,
            endDate: exp.endDate,
            location: exp.location,
            startDate: exp.startDate,
            title: exp.title,
            skills: exp.skills,
            workPlace: exp.workPlace,
          })),
          languages: languagesValues.languages.map(lang => ({
            language: lang.language,
            speaking_level: lang.speaking_level,
            writing_level: lang.writing_level,
          })),
          education: formationsValues.formations.map(form => ({
            description: form.description,
            endDate: form.endDate,
            school: form.school || '',
            startDate: form.startDate,
            title: form.title,
          })),
        },
      },
    });
  };

  return {
    loading,

    error,
    mutate,
  };
};
